import { apiClient } from './client';

export type PlanCode = 'FREE' | 'TRIAL' | 'SOLO' | 'PRO';

export interface PlanDetails {
  id: number;
  code: PlanCode | string;
  maxTrainees: number;
  maxTemplates: number;
  maxTrainingSetDurationDays: number;
  maxAiParseBlockPerDay: number;
  maxAiParseProgramPerDay: number;
  maxAiAssistantPerDay: number;
  hasAutoProlongation: boolean;
  priceMonthly: number;
  priceAnnual?: number;
  currency: string;
}

export interface UsageStats {
  traineeCount: number;
  maxTrainees: number;
  templateCount: number;
  maxTemplates: number;
  canAddTrainee: boolean;
  canAddTemplate: boolean;
  aiParseBlockUsed: number;
  maxAiParseBlockPerDay: number;
  aiParseProgramUsed: number;
  maxAiParseProgramPerDay: number;
  aiAssistantUsed: number;
  maxAiAssistantPerDay: number;
}

export interface SubscriptionResponse {
  plan: PlanDetails;
  status: string;
  currentPeriodEnd: string;
  cancelAtPeriodEnd: boolean;
  usage: UsageStats;
  availablePlans: PlanDetails[];
  canUseWorkoutMode: boolean;
  trialAvailable: boolean;
  trialUsed: boolean;
}

export interface CheckoutRequest {
  planCode: string;
  successUrl: string;
  cancelUrl: string;
}

export interface CheckoutResponse {
  checkoutUrl: string;
}

export interface PortalResponse {
  portalUrl: string;
}

export const subscriptionApi = {
  async getStatus(): Promise<SubscriptionResponse> {
    return apiClient.get<SubscriptionResponse>('/v1/subscription/status');
  },

  async getUsage(): Promise<UsageStats> {
    return apiClient.get<UsageStats>('/v1/subscription/usage');
  },

  async createCheckout(request: CheckoutRequest): Promise<CheckoutResponse> {
    return apiClient.post<CheckoutResponse>('/v1/subscription/checkout', request);
  },

  async createPortal(): Promise<PortalResponse> {
    return apiClient.post<PortalResponse>('/v1/subscription/portal', {});
  },

  async activateTrial(): Promise<void> {
    return apiClient.post<void>('/v1/subscription/trial', {});
  },

  async cancel(): Promise<void> {
    return apiClient.post<void>('/v1/subscription/cancel', {});
  },
};
